// src/components/CookieBanner.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useGlobalContext } from '../../context/GlobalContext';

const CookieBanner = () => {
  const { store, acceptCookie, refuseCookie } = useGlobalContext();
  const { t } = useTranslation();

  const lang = store?.selectedLang || store?.lang || 'fr';

  return (
    <div
      role="dialog"
      aria-label={t("Consentement aux cookies")}
      aria-modal="false"
    >
      <div className="cookie-acceptance-container cookieCard">
        <button type="button" onClick={refuseCookie} className="cookieSkip">
          {t('Continuer sans accepter')}
        </button>
        <h2 className="cookieTitle">{t('Ce site utilise des cookies')}</h2>
        <div
          className="cookieText"
          dangerouslySetInnerHTML={{ __html: store.cookieAcceptance?.[lang] || '' }}
        ></div>
        <div className="cookieActions">
          <button onClick={refuseCookie} className="rfBtn buyOther" translate="true">
            {t("Tout refuser")}
          </button>
          <button onClick={acceptCookie} className="rfBtn sendOrder" translate="true">
            {t("Tout accepter")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
